module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic-fef022fa43a85c2dfa20aeb0db8f0e73.woff2";